/* eslint-disable no-undef */

module.exports = {
  googleMapsKey: GOOGLE_MAPS_KEY
};
